// File: app/src/config/rpe.js
//
// Rate of Perceived Exertion (RPE) scale, 1-10. Shared by the feedback UI and
// the session summary export so the scale is defined in exactly one place.

export const RPE_LABELS = [
  "", // 0 unused
  "Very Light",
  "Light",
  "Light–Moderate",
  "Moderate",
  "Moderate–Hard",
  "Hard",
  "Very Hard",
  "Very Hard+",
  "Extremely Hard",
  "Maximal",
];

export const RPE_COLOURS = [
  "",
  "bg-emerald-600",
  "bg-emerald-500",
  "bg-green-500",
  "bg-lime-500",
  "bg-yellow-500",
  "bg-amber-500",
  "bg-orange-500",
  "bg-orange-600",
  "bg-red-500",
  "bg-red-600",
];

// The same scale as hex, for inline styles (the effort meter's faint
// unpicked segments need an alpha that a Tailwind class can't carry).
export const RPE_HEX = [
  "",
  "#059669",
  "#10b981",
  "#22c55e",
  "#84cc16",
  "#eab308",
  "#f59e0b",
  "#f97316",
  "#ea580c",
  "#ef4444",
  "#dc2626",
];

export const rpeLabel = (rating) => {
  const n = Number(rating);
  if (!Number.isFinite(n) || n < 1 || n > 10) return null;
  return RPE_LABELS[Math.round(n)] || null;
};
